import { SpinnerButton as WalrusSpinnerButton, style } from '@do/walrus';
import styled from 'styled-components';
import vars from '../assets/overwrite-vars.scss';

const SpinnerButton = styled(WalrusSpinnerButton)`
  margin-top: ${style.vars.whitespace.medium};
  border-radius: ${vars.border_radius_xlarge};
`;

export default SpinnerButton;
